export const USERS_FETCH        = Symbol.for('user.list');
export const USER_FETCH         = Symbol.for('user.get');
export const ME_FETCH           = Symbol.for('me.get');
export const NOTIFICATION_FETCH = Symbol.for('notification.list');
export const CONFIG_APPLICATIONS_STATE = Symbol.for('config.applications_state');
